import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, ChipsTogglerButton, Hint, InfoOutlineIcon, Text } from '@common-fe/common-fe';

interface Props extends BoxExtendedProps {
  handleOpenAddLmnPopup?: () => void;
}

const AddProofOfNecessityButton: React.FC<Props> = ({ handleOpenAddLmnPopup, ...props }) => {
  const { t } = useTranslation();

  return (
    <Box
      data-testId="add-proof-of-necessity-button_wrapper"
      direction="row"
      align="center"
      {...props}
    >
      <ChipsTogglerButton
        testId="add-proof-of-necessity"
        onClick={handleOpenAddLmnPopup}
        title={t('Add Letter of Medical Necessity')}
        pad={{ horizontal: 'spacing12', vertical: '10px' }}
        value="add-proof-of-necessity"
        width={{ width: '100%', max: '246px' }}
      />

      <Hint
        testId="add-proof-of-necessity-button_hint"
        hintAlign='right'
        hintWidth={320}
        hintElement={(
          <Box margin={{ left: 'spacing8' }}>
            <InfoOutlineIcon size="16px" color="iconSecondary" />
          </Box>
        )}
      >
        <Text size="small" weight={500}>
          {t(`Proof of necessity or letter of medical necessity is a document from your healthcare
              provider explaining why a specific treatment, service, or product is medically required for your condition.
              This may be needed to approve any expenses not traditionally covered by your plan.`)}
        </Text>
      </Hint>
    </Box>
  );
};

export default AddProofOfNecessityButton;
